<template>
  <nav class="breadcrumb">
    <ul>
      <li v-for="item in currentBreadcrumbs" :key="item.id">
        <u @click="breadcrumbClicked(item.id)">{{ item.text }}</u>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "ListBreadcrumbs",
  methods: {
    breadcrumbClicked(id) {
      this.$store.dispatch("initiateZoom", { taskID: id });
    }
  },
  computed: {
    currentBreadcrumbs() {
      let adjustedBreadcrumbs = this.$store.state.currentBreadcrumbs;
      for (let i = 0; i < adjustedBreadcrumbs.length; i++) {
        if (adjustedBreadcrumbs[i].text.length > 12) {
          adjustedBreadcrumbs[i].text =
            adjustedBreadcrumbs[i].text.slice(0, 12) + "...";
        }
      }
      return adjustedBreadcrumbs;
    }
  }
};
</script>
